import React from 'react';
import { ESnapshotExists, EOrganization, exists } from 'lib/types';

import { useBooleanFlag } from 'utils/flags';
import { LaunchDarklyFlags } from 'lib/types/launchDarklyFlags';
import LookerStudioReport from './LookerStudioReport';
import ColumnReportsV2 from './ColumnReportsV2';

type ReportsProps = {
  activeOrganization: ESnapshotExists<EOrganization>;
};

function Reports({ activeOrganization }: ReportsProps) {
  const enableColumnReportsV2 = useBooleanFlag(
    LaunchDarklyFlags.ENABLE_COLUMN_REPORTS_V2,
    false
  );

  if (!exists(activeOrganization)) return null;

  return (
    <div className="reports-container">
      {enableColumnReportsV2 ? (
        <ColumnReportsV2 />
      ) : (
        <LookerStudioReport activeOrganization={activeOrganization} />
      )}
    </div>
  );
}

export default Reports;
